import { useCallback, useEffect, useState } from 'react'
import { Pencil } from 'lucide-react'
import { useUpdateTaxonomyTranslation } from '@global/hooks/mutations/taxonomy-translations'
import {
  useInvalidateTaxonomyTranslations,
  useInvalidateTaxonomyTranslation,
} from '@global/hooks/queries/taxonomy-translations'
import HandIcon from 'images/hand-icon.svg'
import TaxonomyIcon from 'images/taxonomy_icon.svg'
import { Button } from './button'
import { EditableInput } from './editable-input'
import { PageHeader } from './page-header'
import { t } from '@lingui/core/macro'
import { formatInputNames } from '@taxonomy-translation/utils'

interface Props {
  handlers: any
  item: any
}

export const TranslationDashboardHeader = ({ item, handlers }: Props) => {
  const { mutate } = useUpdateTaxonomyTranslation(item.uuid)
  const [isNameChanged, setIsNameChanged] = useState(false)
  const invalidateTaxonomyTranslations = useInvalidateTaxonomyTranslations()
  const invalidateTaxonomyTranslation = useInvalidateTaxonomyTranslation(item.uuid)

  const handleChangeName = useCallback(
    (name: string) => {
      if (name !== item.name) {
        mutate({ name })
        setIsNameChanged(true)
      }
    },
    [item, mutate],
  )

  // update related data when leave the page if name was changed
  useEffect(
    () => () => {
      if (isNameChanged) {
        void invalidateTaxonomyTranslations()
        void invalidateTaxonomyTranslation()
      }
    },
    [isNameChanged],
  )

  return (
    <PageHeader>
      <PageHeader.LeftBlock>
        <TaxonomyIcon />
        <PageHeader.TitleContainer>
          <PageHeader.Title>
            <div className="flex items-center gap-2">
              <EditableInput
                value={item.name ?? ''}
                onChange={handleChangeName}
                aria-label="Edit name"
              />
              <Pencil size={12} />
            </div>
          </PageHeader.Title>
          <PageHeader.Description>
            {formatInputNames(item.inputs).join(', ')}
          </PageHeader.Description>
        </PageHeader.TitleContainer>
      </PageHeader.LeftBlock>
      <PageHeader.RightBlock>
        <Button
          onClick={handlers.handleFeedback}
          variant="outline"
          className="border-[#0092F3] text-[#0092F3] hover:bg-[#0092F3] hover:text-white"
        >
          <div className="flex gap-2 items-center">
            <HandIcon className="fill-current hover:fill-white" />
            <span>{t`Give feedback`}</span>
          </div>
        </Button>
        <Button onClick={handlers.handleDelete} variant="warn">
          {t`Delete`}
        </Button>
      </PageHeader.RightBlock>
    </PageHeader>
  )
}
